import { createSelector } from 'reselect';

import { RootState } from '../../../store';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { SelectionWindowMode } from './types';

const isWebbingActive = (state: RootState) =>
  state.application.insertingObjectInfo?.type === 'componentDesign' || !!state.application.rewebbingInfo;

export const getSelectionWindowMode = createSelector(
  [isLayoutViewActive, isWebbingActive],
  (inLayoutMode, inWebbingMode): SelectionWindowMode =>
    inLayoutMode ? 'layout' : inWebbingMode ? 'webbing' : 'design',
);
